import React, { useContext, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { StoreContexto } from '../Contexto/Provider';
import '../Estilos/Header.css';
import MenuOpcoes from '../Funções/MenuOpcoes';
import ModalConfirmacao from './ModalConfirmacao';

export default function Hamburguer() {
  const [ativo, setAtivo] = useState(false);
  const { setAuth } = useContext(StoreContexto);
  const [modalConfirmacaoVisivel, setModalConfirmacaoVisivel] = useState(false);


  const navigate = useNavigate();

  const [width, setWidth] = useState(0);
  const elementRef = useRef(null);

  const getListSize = () => {
    try {
      const newWidth = elementRef.current.clientWidth;
      setWidth(newWidth);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    window.addEventListener('resize', getListSize);
  }); //empty dependency array so it only runs once at render

  const lista = [
    {
      icone: require('../Icones/icon dados cadastrais branco.svg').default,
      nome: 'Dados Cadastrais',
      navega: '/my-data',
    },
    ...MenuOpcoes,
    { icone: require('../Icones/icon sair branco.svg').default, nome: 'Sair', navega: '/' },
  ];

  const clicado = () => {
    setAtivo(!ativo);
  };
  return (
    <div className={!ativo ? 'HamburguerMain' : 'HamburguerMain Ativo'}>
      <div className={!ativo ? 'IconHamburguer' : 'IconHamburguer ativo'} onClick={() => clicado()}>
        <img src={require('../Icones/hamburguer.svg').default} style={{ paddingLeft: 45 }} />
      </div>

      {modalConfirmacaoVisivel ? (
        <ModalConfirmacao
          aviso="Deseja realmente sair do sistema?"
          externo
          clicadoVolta={() => {
            setModalConfirmacaoVisivel(false);
          }}
          clicado={async () => {
            setModalConfirmacaoVisivel(false);
            localStorage.clear();
            setAuth({ token: '', idLogin: -1, controleSalvo: '', nomeSalvo: '' });
            navigate('/');
          }}
        />
      ) : null}

      <div className={!ativo ? 'Lista' : 'Lista Ativo'} ref={elementRef}>
        {lista.map((item) => {
          return (
            <div
              id={item.nome}
              key={item.nome}
              className={!ativo ? 'itemLista' : 'itemLista Ativo'}
              onClick={() => {
                if (item.nome == 'Sair') {
                  clicado();
                  // setAuth({ token: '', idLogin: -1, controleSalvo: '', nomeSalvo: '' });
                  setModalConfirmacaoVisivel(true);
                } else {
                  navigate(item.navega);
                }
              }}
            >
              <img
                src={item.icone}
                alt={item.nome}
                height={30}
                width={30}
                style={{ paddingLeft: 30 }}
              />

              <h3 className={!ativo ? 'fonteItem' : 'fonteItem Ativo'}>{item.nome}</h3>
            </div>
          );
        })}
      </div>
    </div>
  );
}
